import React from 'react';
import { Truck, ShieldCheck, Sparkles, Clock, PackageCheck } from 'lucide-react';

const items = [
  { icon: Truck, text: 'Безкоштовна доставка на замовлення бренду MSA від 2000 грн' },
  { icon: Clock, text: 'Відправляємо щодня до 16:00' },
  // This bar speaks for the MSA brand itself, not for whatever product page it
  // happens to sit on — so the certificates line belongs here even though
  // partner cards carry no certificate claims of their own.
  { icon: ShieldCheck, text: 'Якість підтверджена сертифікатами' },
  { icon: PackageCheck, text: 'Нова Пошта · Укрпошта' },
  { icon: Sparkles, text: 'Український бренд MSA' },
];

const PromoBar = () => {
  const all = [...items, ...items, ...items];
  return (
    <div className="w-full bg-[var(--msa-ink)] text-white overflow-hidden">
      <div className="msa-marquee py-2.5 text-[12.5px] font-medium">
        {all.map((i, idx) => {
          const Icon = i.icon;
          return (
            <span key={idx} className="inline-flex items-center gap-2 whitespace-nowrap">
              <Icon className="w-3.5 h-3.5 text-[#9bd34a]" />
              <span>{i.text}</span>
              <span className="opacity-30 px-3">•</span>
            </span>
          );
        })}
      </div>
    </div>
  );
};

export default PromoBar;
